import React from "react";
import {
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
  Link,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
function DocumentOnFileSection({
  title,
  checkboxLabel,
  isOnFile,
  onToggleOnFile,
  documentLink,
  documentName,
  selectedFile,
  displayFileName,
  uploadInputId,
  onSelectFile,
  changeButtonLabel,
  uploadButtonLabel,
  existingPrefix,
  emptyMessage,
  fallbackLinkLabel,
}) {
  return (
    <Grid size={{ xs: 12 }}>
      <Box
        sx={{
          mt: 3,
          p: 2,
          border: "1px solid #e0e0e0",
          borderRadius: 1,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          {title}
        </Typography>

        <FormControlLabel
          control={
            <Checkbox checked={isOnFile} onChange={onToggleOnFile} />
          }
          label={checkboxLabel}
        />

        {isOnFile && (
          <>
            {documentLink ? (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body1">
                  {existingPrefix}
                  <Link
                    href={documentLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ ml: 1 }}
                  >
                    {documentName || fallbackLinkLabel}
                  </Link>
                </Typography>
              </Box>
            ) : (
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ mb: 2 }}
              >
                {emptyMessage}
              </Typography>
            )}

            <Box>
              <input
                accept=".pdf,.doc,.docx"
                style={{ display: "none" }}
                id={uploadInputId}
                type="file"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) onSelectFile(file);
                }}
              />
              <label htmlFor={uploadInputId}>
                <Button variant="contained" component="span">
                  {selectedFile ? changeButtonLabel : uploadButtonLabel}
                </Button>
              </label>
              {selectedFile && (
                <Typography
                  variant="body2"
                  sx={{ ml: 2, display: "inline" }}
                >
                  {displayFileName}
                </Typography>
              )}
            </Box>
          </>
        )}
      </Box>
    </Grid>
  );
}

export default DocumentOnFileSection;
